module.exports = __webpack_public_path__ + "img/6.e088c0cb.jpg";